import { Button, InputText, InputContainer } from "@sellar-io/components";
import { ReactElement } from "react";
import { Alert } from "../../../components/alert/Alert";
import {
  Listbox,
  ListboxInputButton,
} from "../../../components/listbox/Listbox";
import { useIntegrationCreate } from "../../../hooks/api/v2/integration/useIntegrationCreate";
import { SellarIntegrationSettingsDelete } from "./SellarIntegrationSettingsDelete";
import { useSellarCurrentBusiness } from "../../../hooks/useSellarCurrentBusiness.shared";
import { useSellarIntegration } from "../../../hooks/api/v2/integration/useSellarIntegration";
import { IntegrationCard } from "./IntegrationCard";

export const SellarIntegrationSettings = ({
  setMessage,
}: {
  setMessage: (message: string) => void;
}): ReactElement => {
  const { business } = useSellarCurrentBusiness();
  const sellarIntegrationQuery = useSellarIntegration();
  const createIntegrationMutation = useIntegrationCreate();

  const sellarIntegrationId = sellarIntegrationQuery.data?.id;
  const sellarIntegrationApiKey = sellarIntegrationQuery.data?.apiKey;

  return (
    <IntegrationCard
      title={"API key"}
      description={
        "Connect the following inventory management applications with your Sellar API key"
      }
      headerAction={
        sellarIntegrationId ? (
          <SellarIntegrationSettingsDelete
            setMessage={setMessage}
            integrationId={sellarIntegrationId}
          />
        ) : undefined
      }
      actions={
        !sellarIntegrationId ? (
          <Button
            size={"small"}
            onClick={() => {
              if (business?.id) {
                createIntegrationMutation.mutate(
                  {
                    type: "sellar",
                    IntegrationAuthorizations: [],
                  },
                  {
                    onError: () =>
                      setMessage(
                        "There was a problem activating your API keys. Please contact support",
                      ),
                  },
                );
              }
            }}
          >
            Activate API key
          </Button>
        ) : undefined
      }
    >
      {sellarIntegrationApiKey ? (
        <div className="flex flex-col gap-3">
          <InputContainer className="w-full">
            <InputText
              required={false}
              value={sellarIntegrationApiKey}
              className="m-0 w-full"
              disabled
            />
            <Listbox value={""} onChange={() => {}}>
              <ListboxInputButton
                showChildren={false}
                icon={"CONTENT_COPY"}
                compact={true}
                onClick={() =>
                  navigator.clipboard.writeText(sellarIntegrationApiKey)
                }
              >
                Copy Key
              </ListboxInputButton>
            </Listbox>
          </InputContainer>
          <Alert
            type={"warning"}
            message={
              "Your API key should be kept secret at all times. Treat it like a password."
            }
          />
        </div>
      ) : null}
    </IntegrationCard>
  );
};
